export const saloon1ImageOptions = {
  angle: 'saloon1',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    Handrail: 1,
    PleatedBlinds: 1,
    AftCabinLayout: 1,
    FabricCabins: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Floorboard',
      dependency: null
    },
    {
      option: 'Worktop',
      dependency: null
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'Handrail',
      dependency: null
    },
    {
      option: 'PleatedBlinds',
      dependency: null
    },
    {
      option: 'FabricCabins',
      dependency: 'AftCabinLayout'
    },
    {
      option: 'Mast',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC38/views/saloon1.js